import { observable, action } from "mobx";

export default class MoreButtonStore {
    public constructor(rootStore){
        this.rootStore = rootStore;
    }
    public clickCallBack = ()=>{}

    @observable
    public position = {x:0, y:0, width:0, height:0}


    @observable
    public show = false;

    public cardData = null;



    @action
    public showMoreButtonList = async (cardData: any, clickCallBack: Function)=>{
        this.show = true;
        this.cardData = cardData;
        this.clickCallBack = clickCallBack;
    }

    @action
    public hiddenMoreButtonList = ()=>{
        this.show = false;
    }
}